export default __webpack_public_path__ + "static/media/screen-8.5e6a0ac7.jpg";